<template>
  <div class="position-relative" id="examResultAll">
    <neo-print-wrapper title="Exam Report">
      <a-spin :spinning="loading">
        <div class="row">
          <div class="col-12">
            <h4>{{ examData.exam.name }}</h4>
            <p class="mb-2">
              Class: <span class="font-weight-bold">{{ examData.school_class.name }}</span> | Section: <span class="font-weight-bold">{{ examData.section.name }}</span>
            </p>
          </div>

          <div class="col-12">
            <vue-custom-scrollbar class="scroll-area">
              <table class="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Roll No</th>
                    <th
                      v-for="examSubject in examData.class_section_exam_subject"
                      :key="examSubject.id"
                      scope="col"
                    >
                    {{ examSubject.subject.abbreviation }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="student in studentsData"
                    :key="student.id"
                  >
                    <th scope="row">
                      {{ student.roll_no }}
                    </th>
                    <td
                      v-for="examSubject in examData.class_section_exam_subject"
                      :key="examSubject.id"
                      class="px-1"
                    >
                      <span :class="getStudentSubjectMark(examSubject.subject.id, student.student_exam_mark) ? getStudentSubjectMark(examSubject.subject.id, student.student_exam_mark).is_failed ? 'text-danger' : 'text-dark' : ''">
                        {{ getStudentScore(getStudentSubjectMark(examSubject.subject.id, student.student_exam_mark)) }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="!studentsData.length">
                    <td :colspan="examData.class_section_exam_subject.length + 1">
                      <no-data text="No Students" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </vue-custom-scrollbar>
          </div>
        </div>
      </a-spin>

      <!-- Print Button -->
      <div class="position-absolute neo-tr-5 d-print-none">
        <button
          type="button"
          class="btn btn-light btn-sm btn-with-addon"
          @click="print"
        >
          <span class="btn-addon">
            <i class="btn-addon-icon fe fe-printer" />
          </span>
          Print
        </button>
      </div>
    </neo-print-wrapper>
  </div>
</template>

<script>
import { find } from 'lodash'
import NoData from '@/components/layout/NoData/index'
import NeoPrintWrapper from '@/components/layout/Print/Default'

import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  name: 'StudentMarksDisplayAll',
  props: ['examData', 'studentsData'],
  components: {
    vueCustomScrollbar,
    NoData,
    NeoPrintWrapper,
  },
  data: function() {
    return {
      loading: false,
    }
  },
  computed: {
    classStudent: function() {
      return this.studentsData.student
    },
    studentMarks: function() {
      return this.studentsData.student_exam_mark
    },
  },
  methods: {
    getStudentSubjectMark(subjectId, studentMarks) {
      return find(studentMarks, { subject_id: subjectId })
    },
    getStudentScore(markData) {
      let mark = ''
      if (markData) {
        if (this.examData.grades) {
          mark = markData.exam_mark_grade
        }

        if (!this.examData.grades) {
          mark = markData.exam_mark_score
        }
        if (markData.is_absent) {
          mark += '(AB)'
        }
        return mark
      }
      return 'AB'
    },
    print() {
      this.$htmlToPaper('examResultAll')
    },
  },
}
</script>

<style lang="scss">
  .scroll-area {
    position: relative;
    margin: auto;
  }
</style>
